<template>
  <div class="index-elective" v-if="electiveData.length > 0">
    <p class="title">
      <span>{{ $t("public.Course_Center") }}</span>
    </p>
    <div
      class="elective-list"
      v-for="(item, index) in electiveData"
      :key="index"
      @click="routerToDetail(item.trainplan_id)"
    >
      <div class="left-cover">
        <img
          :src="item.trainplan_img ? item.trainplan_img : coverImg"
          @error="item.trainplan_img = coverImg"
        />
      </div>
      <div class="elective-info">
        <p class="over-hide">{{ item.trainplan_name }}</p>
        <p class="elective-time">
          {{ item.opt_start_time }}-{{ item.opt_end_time }}
        </p>
        <div class="c-des">
          <p>
            <i class="zy"></i>
            <span v-if="$i18n.locale == 'zh'"
              >{{ item.resource_num }} {{ $t("courseCentre.resource") }}</span
            >
            <span v-else
              >{{ $t("courseCentre.resource") }}:{{ item.resource_num }}</span
            >
          </p>
          <p>
            <i class="rs"></i>
            <span v-if="$i18n.locale == 'zh'"
              >{{ item.people_num }} {{ $t("courseCentre.person") }}</span
            >
            <span v-else
              >{{ $t("courseCentre.person") }}:{{ item.people_num }}</span
            >
            <b v-if="item.apply_status == 5">({{ $t("courseCentre.full") }})</b>
          </p>
        </div>
      </div>
    </div>
    <p
      class="look-more"
      v-if="electiveData.length == 2"
      @click="$router.push({ name: 'courseCentre' })"
    >
      {{ $t("columnVideo.seeMore") }}
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      electiveData: [],
      coverImg: require("@/assets/img/new/basic_train.png"),
    };
  },
  beforeMount() {
    this.getElectiveList();
  },
  methods: {
    getElectiveList() {
      this.$axios
        .post(`index.php/mobile/select-center/list`, {
          size: 2,
          page: 1,
          include_self_join: 1,
          sort_order: "default",
        })
        .then((res) => {
          this.electiveData = res.data.result.list ? res.data.result.list : [];
        });
    },
    /* 路由跳转 */
    routerToDetail(tid) {
      this.$router.push({
        name: "curricula_variable",
        query: { trainplan_id: tid },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  color: #666666;
  height: 0.72rem;
  line-height: 0.72rem;
  font-size: 0.28rem;
  text-align: center;
  background: #fff;
  border-bottom: solid 0.01rem #eee;
  span {
    position: relative;
    &:before {
      .modified-line;
      left: -0.3rem;
    }
    &:after {
      .modified-line;
      right: -0.3rem;
    }
  }
}
.elective-list {
  display: flex;
  padding: 0.3rem;
  background: white;
  overflow: hidden;
  .left-cover {
    width: 2.8rem;
    height: 1.57rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .elective-info {
    flex: 1;
    overflow: hidden;
    margin-left: 0.3rem;
    .over-hide {
      font-size: 0.28rem;
      font-weight: 750;
      color: #252631;
    }
    .elective-time {
      font-size: 0.22rem;
      color: #666666;
      margin-top: 0.1rem;
    }
  }
  .c-des {
    display: flex;
    margin-top: 0.3rem;
    font-size: 0.22rem;
    color: #005587;
    p:first-child {
      margin-right: 0.3rem;
    }
    i {
      display: inline-block;
      width: 0.18rem;
      height: 0.18rem;
      background-size: 100% 100%;
      vertical-align: middle;
      margin-top: -0.04rem;
      &.zy {
        background-image: url("~@/assets/img/new/zy.png");
      }
      &.rs {
        background-image: url("~@/assets/img/new/usernum.png");
      }
    }
  }
}
.look-more {
  text-align: center;
  line-height: 0.7rem;
  background: white;
  color: #005587;
  font-size: 0.22rem;
  border-top: solid 0.01rem #eee;
}
.modified-line {
  content: "";
  position: absolute;
  top: 50%;
  width: 0.22rem;
  height: 0.02rem;
  background: #666;
}
</style>
